import './Banner.scss';

import classnames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import TRANSLATIONS from '../../translations/translations@default.json';
import { useTheme } from '../../hooks/useTheme';
import { Switch24BannerTerms } from './Switch24BannerTerms';

const MobileFinanceBanner = () => {
	const { isDealsPage } = useSelector((state) => state);
	const { CustomCategoriesEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	const {
		AprRepresentativeString,
		AprPurchaseRateString,
		UseSwitch24,
	} = useSelector((state) => state.featureSwitches);

	const theme = useTheme('financeBanner');
	const titleStyles = classnames(
		'text-title-sm leading-tight',
		theme.repExample.examples.title
	);

	const financeRepExampleText = UseSwitch24
		? TRANSLATIONS.listerFooter.financeExample
				.financeRepExampleWithSwitch24Title
		: TRANSLATIONS.listerFooter.financeExample.financeRepExampleTitle;

	return (
		<li
			className={classnames('pt-0', {
				'sm:py-1': isDealsPage,
				'w-full mobile-banner sm:px-1': !CustomCategoriesEnabled,
				'm-2 lg:mx-4': CustomCategoriesEnabled,
			})}>
			<div
				className={classnames(
					'w-full p-3 border border-solid border-gray-30',
					theme.background,
					{
						rounded: CustomCategoriesEnabled,
						'mobile-banner-border': !CustomCategoriesEnabled,
					}
				)}>
				<div
					className="mr-4"
					style={{ borderRight: '1px solid #E2E7E8' }}></div>
				<div className="flex-col justify-around w-full">
					<div className={titleStyles} data-testid="finance-rep-example-title">
						{financeRepExampleText}
					</div>
					<div
						className={classnames(
							'font-body leading-tight mt-3 text-body-xs text-tertiary'
						)}>
						Representative{' '}
						<span className={titleStyles}>{AprRepresentativeString}% APR</span>{' '}
						(variable),{' '}
						<span className={titleStyles}>{AprPurchaseRateString}% PA</span>{' '}
						purchase rate (variable),{' '}
						<span className={titleStyles}>£1,200</span> assumed credit limit.
					</div>
					<div
						className={classnames(
							'font-body leading-snug mt-3 text-body-xs',
							theme.terms
						)}>
						18+, Credit and Offers are subject to status. Terms apply. NewDay
						Ltd, UK Only.
						<span className="font-bold">
							{' '}
							AO Retail Limited acts as a credit broker exclusively for NewDay
							Ltd and is not a lender.
						</span>
						<div>
							<br />
							{UseSwitch24 && <Switch24BannerTerms />}
						</div>
						<div
							className={classnames(
								'font-body leading-snug mt-3 text-body-xs',
								theme.terms
							)}>
							<span>
								{TRANSLATIONS.listerFooter.financeExample.creditUpfrontText}
							</span>
						</div>
					</div>
				</div>
			</div>
		</li>
	);
};

export default MobileFinanceBanner;
